exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sign-up-page {\n  text-align: center;\n  background-image: url('https://media.giphy.com/media/12FPJ1mfrAkvza/giphy.gif');\n  background-size: cover;\n  position: relative;\n  height: 100vh;\n  color: #ffafaf;\n}\n\n.submit-button {\n  margin-top: 1vh;\n  background-color: #ffafaf;\n}\n\n.createAccount {\n  padding-top: 30vh;\n  /*background-color: #ffafaf;*/\n}\n\n.login {\n  margin-top: 10vh;\n  /*background-color: #ffafaf;*/\n  height: 10vh;\n}\n\n.login-button {\n  background-color: #afffaf;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Space-Janitor/src/app/sign-up/sign-up.component.css
// module id = ../../../../../src/app/sign-up/sign-up.component.css
// module chunks = main